var _ellipse, _circle, _circle2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDotdotdot = function SvgDotdotdot(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99967,
    cy: 13.3333,
    rx: 1.66667,
    ry: 1.66667,
    transform: "rotate(-90 7.99967 13.3333)",
    fill: "#8290A1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99967,
    cy: 2.66634,
    r: 1.66667,
    transform: "rotate(-90 7.99967 2.66634)",
    fill: "#8290A1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99967,
    cy: 8.00033,
    r: 1.66667,
    transform: "rotate(-90 7.99967 8.00033)",
    fill: "#8290A1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDotdotdot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dotdotdot.2a42b3ca.svg";
export { ForwardRef as ReactComponent };